import { Component, OnInit } from '@angular/core';

import { BillingRecurringTypes } from 'app/models/ss-api/responses/upgradable.products.response';
import { DashboardLicenseResponse } from 'app/models/ss-api/responses/dashboard.license.response';
import { SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { ssApiService } from 'app/services/ss-api.service';
import { ReactivateRequest } from '../../models/ss-api/requests/reactivate.request';
import { ReactivateSimulationResponse } from '../../models/ss-api/responses/reactivate.simulation.response';
import { CreditCardResponseArray } from '../../models/ss-api/responses/credit.card.response';
import { GlobalServices } from '../../services/global.service';

export interface IReactivateCDKeyDialogModel {
    title: string;
    License: DashboardLicenseResponse;
    CreditCards: SelectItem[];

}

@Component({
    selector: 'reactivate-cdkey-dialog',
    templateUrl: './reactivate-cdkey-dialog.component.html',
    styleUrls: ['./reactivate-cdkey-dialog.component.css'],

})
export class ReactivateCDKeyDialogComponent implements IReactivateCDKeyDialogModel, OnInit {

    IsBusy: boolean = false;

    License: DashboardLicenseResponse;

    // VARIABLES
    isBusy: boolean = false;

    setUpFee: boolean = false;

    // VARIABLES FROM INTERFACE
    title: string;
    LicenseKey: string;
    FirstName: string;
    LastName: string;
    Email: string;

    BillingDate: Date = new Date();

    Initals: string = '';

    PurchaseDisabled: boolean = true;

    includeSetupFee: boolean = false;

    simulationResponse: ReactivateSimulationResponse = new ReactivateSimulationResponse;

    // CREDIT CARDS
    showAddCreditCard: boolean = false;
    CreditCards: SelectItem[];
    SelectedCreditCard: number;

    Credit: number = 0;

    Item: any = {
        Name: 'VIP3D',
        BillingCycle: BillingRecurringTypes.Monthly,
        Price: '500.00'
    };
    result: any;

    constructor(private api: ssApiService, private gb: GlobalServices) {
    }

    ngOnInit() {

        this.setRequireSetupDate();
        this.simulateReactivation();
        this.GetCredit();

        if (this.CreditCards) {
            this.SelectedCreditCard = this.CreditCards[0].value;
        }

    }

    close() {
        
    }

    setRequireSetupDate() {
        let requireSetupDate = new Date(this.License.NextBillingDate);
        requireSetupDate.setDate(requireSetupDate.getDate() + 30);
        if (new Date() > requireSetupDate) {
            this.includeSetupFee = true;
        }
    }

    simulateReactivation() {
        this.isBusy = true;
        let disposable = this.api.ProductsReactivateSimulation(this.License.Key).subscribe(response => {
            disposable.unsubscribe();
            this.isBusy = false;
            this.simulationResponse = response.Data;
        }, error => {
            disposable.unsubscribe();
            this.isBusy = false;
        });

    }

    getNextBillDate(): Date {
        let newNextBillDate: Date = new Date();
        newNextBillDate.setMonth(newNextBillDate.getMonth() + 1);
        return newNextBillDate;
    }

    confirm() {
        // Confirm Action
        let request = new ReactivateRequest;
        request.LicenseKey = this.License.Key;
        request.Initials = 'reactivate';
        request.CreditCardID = Number(this.SelectedCreditCard);
        request.AdminID = this.gb.AdminID;

        Swal.fire({
          title: 'Reactivate This License Key?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // try to order
                return this.api.ProductsReactivate(request).toPromise();
            }
        }).then(
            async (response: any) => {

                if (response.isDismissed) {
                    // show cancelled
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'No changes are saved.',
                        icon: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1000
                    }).then(() => {
                        this.close();
                    }, () => { }); // keep this line to prevent promise error;
                } else if (!response.value || !response.value.Result) {
                    Swal.fire(
                        {
                            title: 'Error',
                        text: 'Error reactivating License Key',
                            icon: 'error',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then(() => { }, () => { }); // keep this line to prevent promise error;
                } else {
                    // show confirmation
                    Swal.fire(
                        {
                            title: 'Success',
                            text: 'Product Reactivated',
                            icon: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then(() => {
    
                        }, () => { }); // keep this line to prevent promise error;
                }
                this.result = true;
                this.close();
            },
            (dismiss) => {
                if (dismiss === 'cancel') {

                    if (!confirm)
                        return;

                    // show cancelled
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'No changes are saved.',
                        icon: 'error',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1000
                    }).then(() => {
                        this.close();
                    }, () => { }); // keep this line to prevent promise error;
                }
            }).catch(error => {
                Swal.fire(
                    {
                        title: 'Error',
                        text: error.message,
                        icon: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        // this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        // this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });


    }

    cancel() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = false;
        this.close();
    }

    BillingTypeToString(type: BillingRecurringTypes) {
        return BillingRecurringTypes[type];
    }

    BillingTypeToPerString(type: BillingRecurringTypes) {
        if (type == BillingRecurringTypes.Monthly)
            return 'per Month';
        else
            return 'per Year';
    }

    InitialsChanged(data: string) {
        this.CheckPurchaseDisabled();
    }

    CheckPurchaseDisabled() {
        if (this.Initals != '')
            this.PurchaseDisabled = false;
        else
            this.PurchaseDisabled = true;
    }

    CreditCardChanged(e: any) {

    }

    recurringToString(myBillingCycle: BillingRecurringTypes): string {
        if (myBillingCycle == BillingRecurringTypes.Monthly)
            return 'Monthly';
        else
            return 'Yearly';
    }


    cardAdded({cards, newCardId}: {cards: CreditCardResponseArray, newCardId: number}) {
        this.showAddCreditCard = false;
        this.updateCreditCardOptions(cards);
        this.SelectedCreditCard = newCardId;
        this.CheckPurchaseDisabled();
    }

    addCardCanceled() {
        this.showAddCreditCard = false;
    }

    updateCreditCardOptions(newCards: CreditCardResponseArray) {
        this.CreditCards = [];
        newCards.forEach(card => {
            this.CreditCards.push(
                {
                    label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                        ' - Last four: ' + card.LastFour +
                        ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                    value: card.ID
                });
        });
    }


    GetCredit() {
        this.IsBusy = true;

        let subscription = this.api.MemberCredit().subscribe(response => {
            subscription.unsubscribe();
            this.IsBusy = false;
            this.Credit = response.Data;
        }, error => {
            subscription.unsubscribe();
            this.IsBusy = false;
        });

    }

    GetPriceDue(): number {
        let totalPriceDue: number = 0;
        totalPriceDue += this.simulationResponse.ProductPrice;
        totalPriceDue += this.simulationResponse.SetupPrice;
        totalPriceDue -= this.Credit;
        if (totalPriceDue < 0 || Number.isNaN(totalPriceDue))
            totalPriceDue = 0;

        return totalPriceDue;

    }

    CreditUsed(): number {
        if (this.Credit > (this.simulationResponse.ProductPrice + this.simulationResponse.SetupPrice))
            return (this.simulationResponse.ProductPrice + this.simulationResponse.SetupPrice);
        else
            return this.Credit;
    }

}
